<template>
    <div class="floating" v-if="isShow && (!user.vip || user.payLevel !=1)" id="freeSaledFloating">
        <div class="floating-content">
            <div class="default-close freesale-close" @click="openDialog(2)"></div>
            <div class="freesale-body" @click="openDialog(1)">
                <div v-html="$t('language.popup.freeSaledPopup.popupTitle')"></div>
            </div>
        </div>
        <!-- 只有这一个悬浮窗，先放这里 -->
        <freeSaledDialog ref="freeSaledDialog"></freeSaledDialog>
    </div>
</template>

<script>
import commonstate from '@/js/constant.js';
import commonUtils from "@/js/workspace/common_util.js";
import freeSaledDialog from '@/components/popup/upgrade_popups/free_saled_popup';
export default {
    data: function() {
        return {
            isShow: false,
            FREE_SALED_NAME: commonstate.freeSaledName,
        }
    },
    watch: {
        '$store.state.activeTags': function (newValue, oldValue) {
            if (newValue.length) {
                let tag = commonUtils.getActiveTagByStore(this.FREE_SALED_NAME);
                this.isShow = tag&&tag[0].message=='0';
            }
        },
    },
    components: {
        freeSaledDialog,
    },
    computed:{
        user: function(){ 
            return commonUtils.getUser();
        }
    },
    methods: {
        isOpen() {
            let user = commonUtils.getUser();
            //免费用户或付费非无限用户可以获取流量
            if(!user.vip || user.payLevel !=1) {
                //没有活动标记可以获取流量
                let tag = commonUtils.getActiveTagByStore(this.FREE_SALED_NAME);
                this.isShow = !tag||tag[0].message=='0';
            }
        },
        openDialog(type) {
            this.$refs.freeSaledDialog.type = type;
            this.$refs.freeSaledDialog.isShow = true;
        },
    }
}
</script>

<style lang="less" scoped>
#freeSaledFloating {
    width: 83px;/*no*/
    height: 103px;/*no*/
    position: absolute;
    right: 57px;/*no*/
    bottom: 120px;/*no*/
    z-index: 2;
}

.freesale-close {
    width: 16px;/*no*/
    height: 16px;/*no*/
    font-size: 8px;/*no*/
    line-height: 16px;/*no*/
    top: -4px;/*no*/
    right: -4px;/*no*/
    background: rgba(25, 89, 140, 0.6);
    backdrop-filter: blur(10px);
    &:hover {
      background: rgba(255, 134, 59, 0.8);
    }
}

.floating-content {
    height: 100%;
}

.freesale-body {
    height: 100%;
    background: url('../../assets/images/family-day-2026/floating-bg.png') no-repeat;
    background-size: 100% 100%;
    cursor: pointer;
    text-shadow: 0px 1px 2px #292929;
    text-align: center;
    /deep/ span {
      color: #FF7621;
    }
    div {
      font-variation-settings: "opsz" auto;
      font-feature-settings: "kern" on;
      color: #FFFFFF;
      padding: 10px 8px;/*no*/
      font-size: 12px;/*no*/
      font-weight: 900;
      line-height: 100%;
    }
}
</style>


// WEBPACK FOOTER //
// src/components/floating/free_saled_floating.vue